const CREATE_PAYMENT_PAGE_REQUEST ='CREATE_PAYMENT_PAGE_REQUEST';
const CREATE_PAYMENT_PAGE_SUCCESS ='CREATE_PAYMENT_PAGE_SUCCESS';
const CREATE_PAYMENT_PAGE_ERROR ='CREATE_PAYMENT_PAGE_ERROR';

const GET_PAYMENT_PAGE_DETAILS_REQUEST ='GET_PAYMENT_PAGE_DETAILS_REQUEST';
const GET_PAYMENT_PAGE_DETAILS_SUCCESS ='GET_PAYMENT_PAGE_DETAILS_SUCCESS';
const GET_PAYMENT_PAGE_DETAILS_ERROR ='GET_PAYMENT_PAGE_DETAILS_ERROR';

const UPDATE_PAYMENT_PAGE_DETAILS_REQUEST = 'UPDATE_PAYMENT_PAGE_DETAILS_REQUEST';
const UPDATE_PAYMENT_PAGE_DETAILS_SUCCESS= 'UPDATE_PAYMENT_PAGE_DETAILS_SUCCESS';
const UPDATE_PAYMENT_PAGE_DETAILS_ERROR= 'UPDATE_PAYMENT_PAGE_DETAILS_ERROR';


const HIDE_PAYMENT_PAGE_LOADER = 'HIDE_PAYMENT_PAGE_LOADER';
const SHOW_PAYMENT_PAGE_LOADER = 'SHOW_PAYMENT_PAGE_LOADER';
const FETCH_PAYMENT_PAGE_REQUEST = 'FETCH_PAYMENT_PAGE_REQUEST';
const FETCH_PAYMENT_PAGE_SUCCESS = 'FETCH_PAYMENT_PAGE_SUCCESS';
const FETCH_PAYMENT_PAGE_ERROR = 'FETCH_PAYMENT_PAGE_ERROR';
const FETCH_TRANSACTION_PAYMENT_REQUEST =
    'FETCH_TRANSACTION_PAYMENT_REQUEST_PAYMENT_PAGE';
const FETCH_TRANSACTION_PAYMENT_SUCCESS =
    'FETCH_TRANSACTION_PAYMENT_PAGE_SUCCESS';
const FETCH_TRANSACTION_PAYMENT_ERROR = 'FETCH_TRANSACTION_PAYMENT_PAGE_ERROR';
const VIEW_PAY_LINK_REQUEST = 'VIEW_PAY_LINK_REQUEST_PAYMENT_PAGE';
const VIEW_PAY_LINK_SUCCESS = 'VIEW_PAY_LINK_SUCCESS_PAYMENT_PAGE';
const VIEW_PAY_LINK_ERROR = 'VIEW_PAY_LINK_ERROR_PAYMENT_PAGE';
const RE_SHARE_PAY_PAGE_ERROR = 'RE_SHARE_PAY_PAGE_ERROR';
const RE_SHARE_PAY_PAGE_REQUEST = 'RE_SHARE_PAY_PAGE_REQUEST';
const RE_SHARE_PAY_PAGE_SUCCESS = 'RE_SHARE_PAY_PAGE_SUCCESS';
const GENERATE_REPORT_REQUEST_PAYMENT_PAGE = 'GENERATE_REPORT_REQUEST_PAYMENT_PAGE';
const GENERATE_REPORT_SUCCESS_PAYMENT_PAGE = 'GENERATE_REPORT_SUCCESS_PAYMENT_PAGE';
const GENERATE_REPORT_ERROR_PAYMENT_PAGE = 'GENERATE_REPORT_ERROR_PAYMENT_PAGE';

export {
    CREATE_PAYMENT_PAGE_REQUEST,
    CREATE_PAYMENT_PAGE_SUCCESS,
    CREATE_PAYMENT_PAGE_ERROR,
    GET_PAYMENT_PAGE_DETAILS_REQUEST,
    GET_PAYMENT_PAGE_DETAILS_SUCCESS,
    GET_PAYMENT_PAGE_DETAILS_ERROR,
    UPDATE_PAYMENT_PAGE_DETAILS_REQUEST,
    UPDATE_PAYMENT_PAGE_DETAILS_SUCCESS,
    UPDATE_PAYMENT_PAGE_DETAILS_ERROR,
    SHOW_PAYMENT_PAGE_LOADER,
    HIDE_PAYMENT_PAGE_LOADER,
    FETCH_PAYMENT_PAGE_REQUEST,
    FETCH_PAYMENT_PAGE_SUCCESS,
    FETCH_PAYMENT_PAGE_ERROR,
    FETCH_TRANSACTION_PAYMENT_REQUEST,
    FETCH_TRANSACTION_PAYMENT_SUCCESS,
    FETCH_TRANSACTION_PAYMENT_ERROR,
    VIEW_PAY_LINK_REQUEST,
    VIEW_PAY_LINK_SUCCESS,
    VIEW_PAY_LINK_ERROR,
    RE_SHARE_PAY_PAGE_ERROR,
    RE_SHARE_PAY_PAGE_REQUEST,
    RE_SHARE_PAY_PAGE_SUCCESS,
    GENERATE_REPORT_REQUEST_PAYMENT_PAGE,
    GENERATE_REPORT_SUCCESS_PAYMENT_PAGE,
    GENERATE_REPORT_ERROR_PAYMENT_PAGE,
};
